<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 14:20:31
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="msgbox">
      <div class="bigbox">
        <div class="join_game"  @click="joinGame">
          <img
            src="https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/join_game.png"
            alt
          />
        </div>
      </div>
      <img
        class="close"
        @click="clickClose"
        src="https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/close_news.png"
        alt
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      value: false
    };
  },

  computed: {},
  methods: {
    clickClose() {
      this.value = false;
      this.callback("cancel");
    },
    joinGame() {
      // alert("success")
      this.value = false;
      this.callback("ok");
      // this.$goPage("zzll");
    }
  },
  created() {},
  mounted() {}
};
</script>
// <style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style lang="stylus" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.msgbox {
  background-image: url('https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/tcygc-bird-2021-06/success_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  width: 328px;
  height: 373px;
}

.msgbox .title {
  font-size: 16px;
  font-family: PingFang SC;
  color: #ffffff;
  background-color: #e82f1c;
  min-height: 45px;
  line-height: 45px;
  text-align: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.msgbox .content {
  width: 90%;
  margin: 0 auto;
  text-align: center;
}

.msgbox .content .tip1 {
  padding-top: 5px;
  line-height: 27px;
  font-size: 16px;
  font-family: PingFang SC;
  color: #e72b1a;
}

.msgbox .content .tip2 {
  padding-top: 5px;
  line-height: 20px;
  font-size: 12px;
  font-family: PingFang SC;
  color: rgba(51, 51, 51, 1);
}

.msgbox .content input {
  border-radius: 3px;
  width: 100%;
  height: 37px;
  text-indent: 15px;
  color: #666666;
  background: rgba(237, 237, 237, 1);
}

.msgbox .content .input_txt {
  width: 100%;
  margin: 12px auto 0 auto;
}

.msgbox .content .input_code {
  width: 100%;
  margin: 12px auto 0 auto;
  display: flex;
}

.msgbox .content .input_code .left {
  width: 55%;
}

.msgbox .content .input_code .right {
  width: 45%;
}

.msgbox .content .input_code .right >div {
  border-radius: 6px;
  width: 90%;
  margin-left: 10%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #ffffff;
  color: rgba(233, 48, 26, 1);
}

.msgbox .btns {
  height: 40px;
  display: flex;
  justify-content: center;
  margin: 12px auto 0 auto;
}

.msgbox .btns > div {
  width: 35%;
}

.msgbox .close {
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform translateX(-50%);
  width: 31px;
  height: 31px;
  z-index: 1001;
}

.address_detail {
  line-height: 20px;
  font-size: 12px;
  font-family: PingFang SC;
  color: rgba(51, 51, 51, 1);
  text-align: justify;
}

.join_game {
  width: 137px;
  height: 51px;
  // position: relative;
  // z-index: 2000;

  img {
    width: 100%;
    height: 100%;
  }
}

.bigbox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 270px;
  position: relative;
  z-index: 2000;
}
</style>